import { BaseRouteService } from 'core/services';

class WarehouseActivityRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'warehouse-activities/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	get(id, options) {
		return super.get(this.base + '{id}/{?embed}', id, options);
	}

	create() {
		return super.create(this.base);
	}

	receiveShipment() {
		return super.create(this.base + 'receive');
	}

	adjustInventory() {
		return super.create(this.base + 'adjustment');
	}

	update(resource) {
		return super.update(this.base + '{id}', resource);
	}

	delete(resource) {
		return super.delete(this.base + '{id}', resource);
	}
}

export default WarehouseActivityRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/WarehouseActivityRouteService.js